import React from 'react';
import Work from './Work';
import { Proyectos, SectionWorks } from '../styles';

const Works = () => {
    return (
        <SectionWorks id="works">
            <h3>Works</h3>
            {Proyectos.map(proyecto => (
                <Work 
                    key={proyecto.id}
                    proyecto={proyecto}
                    tech={proyecto.tech}
                />
            ))}
        </SectionWorks>
    );
}
 
export default Works;